import FetchJSONP from 'fetch-jsonp';

export function jsonp(
  url: string,
  options?: { timeout?: number; jsonpCallback?: string; jsonpCallbackFunction?: string },
) {
  const defaultOptions = {
    //请求时长默认最长60秒钟
    timeout: 1000 * 60,
  };

  options = Object.assign({}, defaultOptions, options);
  const result = FetchJSONP(url, options);

  return receiveData(result);
}

const receiveData = function (result: any) {
  return result.then(function (res: { ok: boolean; json: Function }) {
    if (res.ok) {
      return res.json();
    }
  });
};
